import React, { Component, PropTypes } from 'react';
import { extractCourtName } from '../../util/EventUtil';
import { EMPTY_TABLE_CELL } from '../../util/constants';

export default class EventCourtName extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired
  };

  extractCourtName() {
    const { event } = this.props;
    return extractCourtName(event) || EMPTY_TABLE_CELL;
  }

  render() {
    return <span>{this.extractCourtName()}</span>;
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventCourtName.jsx